import IconMenuProps from "../../model/icon-menu-props";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function IconMenu(props: IconMenuProps){
    return(
        <Button 
            sx={{
                    color:"rgba(255,255,255,0.9)",
                    marginLeft:2,
                }} 
            size={'small'} 
            variant="text" 
            href={props.href}
            target='_blank'
            startIcon={props.icon}
            
        >
            {props.text}
        </Button>
    )
}